module.exports = __webpack_public_path__ + "img/3-4.66fb8c0c.png";